import {
  formatPercentage,
  CurrencyValue,
  formatCurrency,
  BarChart
} from '@blockanalitica/ui';
import type { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

export default function AtRiskChartPerDrop({
  data
}: {
  data: SimpleChartData[];
}) {
  const theme = useTheme();
  const defaultConfig: ChartConfig = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'category'
          }
        }
      }
    };
  }, []);

  const yScaleValueFormatter = (value: string | number) => {
    return formatCurrency(Number(value), { maximumFractionDigits: 5 });
  };
  const valueFormatter = (value: string | number) => {
    return (
      <CurrencyValue
        value={value}
        variant="dynamic"
        options={{ currency: 'USD' }}
      />
    );
  };

  const xScaleValueFormatter = (value: string | number) => {
    return `-${formatPercentage(Number(value) / 100)}`;
  };

  const subValueFormatter = (value: string | number) => {
    return `Price drop: -${formatPercentage(Number(value))}`;
  };

  const datasets = [
    {
      xField: 'price_change',
      yField: 'collateral_liquidated',
      label: 'At Risk',
      backgroundColor: theme.colors.primary
    }
  ];

  return (
    <BarChart
      data={data}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      xScaleValueFormatter={xScaleValueFormatter}
      subValueFormatter={subValueFormatter}
      config={defaultConfig}
    />
  );
}
